import React from 'react';
import { Redirect } from 'react-router-dom';

// Authentication related pages
import Login from '../pages/Authentication/Login';
import Logout from '../pages/Authentication/Logout';
import Register from '../pages/Authentication/Register';
import ForgetPasswordPage from '../pages/Authentication/ForgotPassword';

// Dashboard
import Dashboard from "../pages/Dashboard/index";
import Back from "../pages/CampInfo/Back";
import DataStore from "../pages/DataStorage/DataStore";
import FileUploadedInfo from "../pages/FileUploadedInfo/FileUploadedInfo"
import Testimony from "../pages/Testimony/Testimony"
import TestimonyList from "../pages/TestimonyList/TestimonyList"
import TestimonyVerify from "../pages/TestimonyVerify/TestimonyVerify"
import TestimonyManager from "../pages/TestimonyManager/TestimonyManager";
import TestimonyDetail from "../pages/TestimonyManager/TestimonyDetail";
import LocationPoint from "../pages/LocationPoint/LocationPoint";
import Facility from "../pages/Facility/AddFacility";
import FacilityManager from "../pages/Facility/FacilityManager";
import FacilityDetail from "../pages/Facility/FacilityDetail";
import FacilityDataTypes from '../pages/Facility/FacilityDataTypes';
import SearchUser from '../pages/Register/SearchUser';
import TodoAdmin from '../pages/Todo/TodoAdmin';
import FAQs from "../pages/MiscPages/FAQs";

const authProtectedRoutes = [
	{ path: '/dashboard', component: Dashboard },

	{ path: '/campinfo', component: Back },
	{ path: '/locationPoint', component: LocationPoint},

	{ path: '/facility-add', component: Facility },
	{ path: '/facility-manager', component: FacilityManager},
	{ path: '/facility-data-type', component: FacilityDataTypes},
	{ path: '/facility-detail', component: FacilityDetail},

	{ path: '/datastore', component: DataStore },
	{ path: '/fileUploadedInfo', component: FileUploadedInfo },

	{ path: "/testimony", component: Testimony},
	{ path: "/testimonyList", component: TestimonyList},
	{ path: "/testimonyVerify", component: TestimonyVerify},
    { path: "/testimonyManager", component: TestimonyManager},
    { path: "/testimonyDetail", component: TestimonyDetail},
	{ path: "/register-user", component: SearchUser},
	{ path: "/admin", component: TodoAdmin},
    { path: "/faqs", component: FAQs},
	//{ path: "/testimonyDirect", component: TestimonyDirect},
	{ path: '/register', component: Register },

	// this route should be at the end of all other routes
	{ path: '/', exact: true, component: () => <Redirect to="/dashboard" /> },
];

const publicRoutes = [
	{ path: '/logout', component: Logout },
	{ path: '/login', component: Login },
	{ path: '/forgot-password', component: ForgetPasswordPage },
];

export { authProtectedRoutes, publicRoutes };
